import { WidgetHelper } from '@/helpers/Widget'

import BenefitsWidget from '@/modules/BenefitsWidget/components/BenefitsWidget'

const widgetSelector = '.benefitsWidget'

WidgetHelper.reTry(widgetSelector, BenefitsWidget)
window.addEventListener('reInitializeWidgets', WidgetHelper.reTry.bind(this, widgetSelector, BenefitsWidget))
